export default __webpack_public_path__ + "static/media/welcome-bg8.14ae4a73.png";